'use client';

import React, { FC } from 'react';
import { FacetFilter } from 'shared/types/query/ProductQuery';
import { Button } from 'components/ui/button';
import Close from 'icons/close';

interface ProductListAppliedFiltersProps {
  activeFacets: FacetFilter[];
  onFilterClick: (filter: FacetFilter) => void;
  onClearAll: () => void;
}

const ProductListAppliedFilters: FC<ProductListAppliedFiltersProps> = ({ activeFacets, onFilterClick, onClearAll }) => {
  // Helper function to get display label for filter terms
  const getDisplayLabel = (facet: FacetFilter, term: string) => {
    // For Ready to Ship (isOnStock), show "Ready to Ship" instead of "true"
    if (facet.key === 'variants.availability.isOnStock' && term === 'true') {
      return 'Ready to Ship';
    }
    return term;
  };

  return (
    activeFacets.length > 0 && (
      <div className="flex flex-row items-start gap-3" role="region" aria-labelledby="applied-filters-label">
        <p id="applied-filters-label" className="whitespace-nowrap py-1 text-sm font-normal">
          Applied Filters:{' '}
        </p>
        <div className="flex flex-wrap gap-3 pb-3">
          {activeFacets.flatMap((facet) =>
            facet?.facetData?.terms?.map((term) => {
              const displayLabel = getDisplayLabel(facet, term);
              return (
                <div
                  className="flex cursor-pointer flex-row items-center gap-2 rounded-full bg-neutral-250 px-2 py-1"
                  key={`${facet.key}-${term}`}
                  onClick={() =>
                    onFilterClick({
                      key: facet.key,
                      urlKey: facet.urlKey,
                      facetData: { ...facet.facetData, terms: [term] },
                    })
                  }
                  role="button"
                  aria-label={`Remove filter ${displayLabel}`}
                >
                  <p className="text-sm font-normal">{displayLabel}</p>
                  <Close className="size-2" aria-hidden="true" />
                </div>
              );
            }),
          )}

          <Button className="text-sm font-normal underline" onClick={onClearAll} aria-label="Clear all filters">
            Clear all
          </Button>
        </div>
      </div>
    )
  );
};

export default ProductListAppliedFilters;
